<template>
	<v-sheet id="project-properties"
		rounded
		class="mb-4">
		<properties-table :project="project" :properties="properties">
			<v-item-group v-if="auth.user_type === 1 || auth.user_type === 2" class="v-btn-toggle">
				<import-properties :project="project" />
				<v-dialog v-model="dialogAdd" transition="scroll-x-reverse-transition" max-width="900">
					<template #activator="{ on, attrs }">
						<v-btn color="success"
							elevation="0"
							small
							v-bind="attrs"
							v-on="on">
							<v-icon left class="white--text">mdi-plus</v-icon>
							Add Property
						</v-btn>
					</template>
					<template #default>
						<v-card>
							<v-card-title>
								<div>Add Property</div>
								<v-icon right class="ml-auto theme--dark" @click="dialogAdd = false">mdi-close</v-icon>
							</v-card-title>
							<v-divider class="mb-5" />
							<v-card-text>
								<property-form :project="project" @success="dialogAdd = false"></property-form>
							</v-card-text>
						</v-card>
					</template>
				</v-dialog>
			</v-item-group>
		</properties-table>
	</v-sheet>
</template>
<script>
import PropertiesTable from '@/Pages/Backend/Properties/Table'
import PropertyForm from '@/Pages/Backend/Properties/Form'
import ImportProperties from '@/Pages/Backend/Properties/Components/ImportProperties'

export default {
	components: { PropertiesTable, PropertyForm, ImportProperties },
	props: {
		properties: {
			type: [Array, Object],
			default: () => {},
			required: true
		},
		project: {
			type: [Array, Object],
			default: () => {},
			required: true
		}
	},
	data () {
		return {
			dialogAdd: false,
			auth: this.$page.props.auth
		}
	}
}
</script>
